import axios from 'axios'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IConsumerProductService, IEquivOptions, IFilterOptions, IPrdAttrOptions} from "../PA.MD.Core/PA.MD.IF.Aspects";


export interface IConsumerProductServiceRequest {
  requestType: string,
  attributeName?: string,
  options?: any
}

export interface IConsumerProductServiceResponse {
  request: IConsumerProductServiceRequest,
  bError: boolean,
  sErrors: string[],
  results: any
}

export class ConsumerProductService
  implements IConsumerProductService
{

  constructor(){

  }

  getDistinctValues(attributeName: string, opts: IFilterOptions): Promise<any[]> {
    return ConsumerProductService.makeRequest("getDistinctValues", undefined, opts);
  }

  getConsumerProducts(opts: IFilterOptions): Promise<number[]> {
    return ConsumerProductService.makeRequest("getConsumerProducts", undefined, opts);
  }

  getConsumerProductEquiv(opts: IEquivOptions): Promise<{ wbProdId: number; equivFactor: number; attributeValue: string }[]> {
    return ConsumerProductService.makeRequest("getConsumerProductEquiv", undefined, opts);
  }

  getConsumerProductAttributes(wbProdId: string): Promise<any> {
    return ConsumerProductService.makeRequest("getConsumerProductAttributes", wbProdId, undefined);
  }

  getConsumerProductAttrValues(opts: IPrdAttrOptions): Promise<{[id:string]: {wbProdId: number; attributeValue: string}}> {
    return ConsumerProductService.makeRequest("getConsumerProductAttrValues", undefined, opts);
  }

  private static makeRequest(requestType: string,
                             attributeName: string,
                             options: any): Promise<any>
  {

    return new Promise<any[]>((resolve, error) => {

      let consProdRequest: IConsumerProductServiceRequest = {
        requestType: requestType
      }

      if(attributeName)
        consProdRequest.attributeName = attributeName

      if(options)
        consProdRequest.options = options

      let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base,"/"));
      if(sEndPoint.endsWith('/'))
        sEndPoint += 'consumerProduct';
      else
        sEndPoint += '/consumerProduct';

      axios.post(sEndPoint, {data: {request: consProdRequest}})
        .then((resp: any) => {
          let responseData: IConsumerProductServiceResponse = resp.data;
          if('request' in responseData) {
            if(responseData.bError){
              error("Consumer Product Service Response: " + (responseData.sErrors || ['Unknown']).toString())
            } else {
              resolve(responseData.results)
            }
          } else {
            error('Unable to parse Consumer Product Service Web Response: ' + responseData );
          }
        })
        .catch((err:any) => {
          error('Unable to obtain Consumer Product Service Results from Server. ' + err);
        });
    });
  }


}

